import * as React from 'react';
import { observer } from 'mobx-react';
import { Button, Colors, Display } from 'Views/Components/Button/Button';
import { themeStore } from 'Models/ThemeStore';
import { useNavigate } from 'react-router-dom';
import Card from 'Views/Components/_HumanWritten/Card/Card';

/**
 * Laid out exactly like {@link PageNotFound}: the two are the same moment for the person who lands on
 * them - a page they can't use - and differ only in the reason. There is deliberately no Logout here;
 * signing out does not give anyone a permission they lack.
 */
export function PageAccessDenied() {
	const navigate = useNavigate();

	return (
		<div className="body-content error-page">
			<div
				className="error-page__background"
				style={{
					backgroundImage: `url(${themeStore.errorPageBackgroundImageURL})`,
					backgroundSize: 'cover',
					backgroundPosition: 'center',
				}}
			/>
			<div className="error-page__content">
				<Card>
					<h5>No access</h5>
					<p className="body--content">You don&#8217;t have permission to use this page.</p>
					<Button
						display={Display.Solid}
						colors={Colors.Primary}
						newStyles
						onClick={() => {
							navigate('/ferry-schedule');
						}}
					>
						Go to home page
					</Button>
				</Card>
			</div>
		</div>
	);
}

export default observer(PageAccessDenied);
